import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Axios from 'axios';

import {url} from '../../../Config';

import './Session.css';
import ListeOverviews from '../../../components/liste-overviews/ListeOverviews';
import SessionOverview from '../../../components/session-overview/SessionOverview';
import Navbar from '../../../components/navbar/Navbar';
import Sidebar from '../../../components/sidebar/Sidebar';

class ListeSession extends Component {
    constructor() {
        super();
        this.state = {
            sessions: [],
            isLoading: true,
            isEmptyRecords: false
        }
    }

    componentDidMount(){
        const profil = sessionStorage.getItem('profil');
        if(profil !== 'secretaire'){ this.props.history.goBack(); }
        
        const token = sessionStorage.getItem('token');

        Axios.get(`${url}/api/sessions?token=${token}`).then(
            res => {
                const {sessions, count} = res.data;
                if(count == 0) {
                    this.setState({isEmptyRecords: true});
                }
                this.setState({isLoading: false, sessions});
            }
        );
    }

    showLoader = () => {
        if(this.state.isLoading){
            return (
                <div class="d-flex justify-content-center">
                    <strong>Chargement...</strong>
                </div>
            )
        } else {
            return '';
        }
    }

    showEmptyRecordsAlert = () => {
        if(this.state.isEmptyRecords){
            return (
                <div className="alert alert-info m-5">
                    Aucune session n'est programmé actuellememnt !
                </div>
            )
        } else {
            return '';
        }
    }

    render() {
        const {sessions} = this.state;

        return (
            <>
                <Navbar />
                <Sidebar />
                <div className="col-md-10 offset-md-2 mt-5">
                    <div className="row">
                        <ListeOverviews />
                    </div>

                    <div id="sessions-content" classNam="row">
                        <div className="col-md-12">
                            <div className="row sessions bg-white">
                                <div className="col-md-12 px-4 py-2">
                                    <div className="clearfix sessions-filter">
                                        <div className="float-left">
                                            <span className="float-left titre text-secondary">Sessions</span>
                                        </div>
                                        <div className="float-right">
                                            <Link to="/secretaire/new-session" className="btn button-default button-green">Nouvelle Session</Link>
                                            {/* <div className="filter-group">
                                                <input type="text" name="search" className="search" placeholder="Rechercher" />
                                                <button className="search-button button-green">GO</button>
                                            </div> */}
                                        </div>
                                    </div>                                
                                </div>

                                <div className="col-md-12 px-0 pb-5">
                                    {this.showLoader()}
                                    {this.showEmptyRecordsAlert()}

                                    {sessions.map((session, index) => (
                                        <SessionOverview key={index} session={session}/>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ListeSession;